import moment from 'moment'

interface Props {
  vendor_fk_code: string
  customer_fk_code: string
  vendorCount: number
  countryCount: number
  customerCount: number
  pi_date: string | Date
}

const formatRefInvoice = (props: Props): string => {
  const { vendor_fk_code, customer_fk_code, vendorCount, countryCount, customerCount, pi_date } = props
  if (!vendor_fk_code || !customer_fk_code) return ''

  const year = moment(pi_date).format('YY')
  const v = vendorCount.toString().padStart(3, '0')
  const co = countryCount.toString().padStart(3, '0')
  const cu = customerCount.toString().padStart(3, '0')

  return `${vendor_fk_code} ${v}/${co}/${customer_fk_code}${cu}/${year}`
}

export default formatRefInvoice
